import gql from 'graphql-tag';

export default gql`
    query GetEquipmentsByAssetType($assetType: String) {
        getEquipmentsByAssetType(assetType: $assetType) {
            id
            name
        }
    }
`;
